
import { defineComponent, ref, computed } from '@vue/composition-api';
import PackageGymExplorer from '~/components/v3/home/PackageGymExplorer.vue';
import { isMobileEffect } from '~/effects/matchMedia';
import { Video } from '@fc/angie-ui';

export default defineComponent({
  name: 'ConsoleTracker',
  components: {
    PackageGymExplorer,
    Video,
  },
  setup() {
    const isMobile = isMobileEffect();

    const appScreens = ref([
      {
        title: 'Track Your Progress',
        text: ' Trackers analyze your movements, calculate strike speed, and boost your output score. Watch your score rise as your performance improves.',
        videoComponent: {
          firstFrame: 'https://a.storyblok.com/f/152150/1360x2438/e1f42f569f/9x16-track-your-progress.png',
          mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/track-your-progress-002.mp4 ',
          webmVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/track-your-progress-002.webm',
        },
      },
      {
        title: 'Push yourself into the gain zone',
        text: ' Each round sets a punch goal, pushing you closer to new achievements — just like having a personal coach driving you forward.',
        videoComponent: {
          firstFrame: 'https://a.storyblok.com/f/152150/1366x2440/44c403b7d0/9x16-push-yourself.png',
          mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/push-yourself-002.mp4 ',
          webmVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/push-yourself-002.webm',
        },
      },
      {
        title: 'Set goals and benchmark yourself',
        text: 'Join monthly challenges with the FightCamp community, and use others’ performance to measure and push your own progress.',
        videoComponent: {
          firstFrame: 'https://a.storyblok.com/f/152150/1366x2436/c0f5099946/9x16-set-goals.png',
          mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/set-goals-002.mp4 ',
          webmVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/set-goals-003-vp9.webm',
        },
      },
    ]);

    // @ts-ignore
    const { $device } = useNuxtApp();

    return {
      isMobile,
      appScreens,
      isSafari: computed(() => $device.isSafari),
    };
  },
});
